import IndicatorService from 'src/modules/indicator/indicatorService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'INDICATOR_VIEW';

const indicatorViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: indicatorViewActions.FIND_STARTED,
      });

      const record = await IndicatorService.find(id);

      dispatch({
        type: indicatorViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: indicatorViewActions.FIND_ERROR,
      });

      getHistory().push('/indicator');
    }
  },
};

export default indicatorViewActions;
